import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import logo from '../../assets/logo.png';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${apiUrl}/login`, {
        email,
        password,
      });
      const { token, role } = response.data.result;
      localStorage.setItem('token', token);

      if (role === 'restaurante') {
        navigate('/admin');
      } else if (role === 'empleado') {
        navigate('/waiter');
      } else if (role === 'admin') {
        navigate('/RetirosAdminPage');
      } else {
        setError('Rol desconocido');
      }
    } catch (error) {
      setError('Credenciales incorrectas, intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-bg p-6 relative overflow-hidden">
      {/* Glow decorativo */}

      <div className="relative w-full max-w-md">
        {/* Brand */}
        <div className="flex items-center gap-3 mb-8 justify-center">
          <img
            src={logo}
            alt="ServiceIn"
            className="w-11 h-11 rounded-xl object-contain"
          />
          <span className="text-xl font-semibold text-ink">ServiceIn</span>
        </div>

        {/* Card */}
        <div className="si-card p-8">
          <h1 className="text-2xl font-bold text-ink mb-1 tracking-tightish">
            Iniciar sesión
          </h1>
          <p className="text-sm text-ink-3 mb-6">
            Accedé a tu cuenta para administrar tus propinas.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="si-label" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="si-input"
                placeholder="tucorreo@ejemplo.com"
                autoComplete="email"
              />
            </div>

            <div>
              <label className="si-label" htmlFor="password">Contraseña</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="si-input"
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="rounded-xl border border-danger/30 bg-danger/10 px-3 py-2.5 text-sm text-danger">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="si-btn-primary w-full py-3"
            >
              {loading ? 'Ingresando...' : 'Iniciar sesión'}
            </button>
          </form>

          <div className="mt-5 text-center">
            <Link
              to="/forgot-password"
              className="text-sm text-purple hover:text-purple/80 transition"
            >
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
        </div>

        <p className="text-center text-xs text-ink-3 mt-6">
          ServiceIn · Gestión de propinas
        </p>
      </div>
    </div>
  );
}

export default Login;
